import BaseService from "../BaseService";
import _ from "lodash";

class CustomerService extends BaseService {
    getByPhone = async (phone) => {
        var data = await this._api.post("/customer/getbyphone", { phone });
        return data;
    };


    getByID = async (id) => {
        var data = await this._api.post("/customer/getbyid", { id });
        return data;
    };


    list = async (filter) => {
        var data = await this._api.post("/customer/list", filter);
        return data;
    };

    updateStats = async (id) => {
        var data = await this._api.post("/customer/update_stats", { id });
        return data;
    };



    getDebt = async (id, start) => {
        var data = await this._api.post("/customer/getdebt", { id, start });
        return data;
    };


    create = async (customer) => {
        var data = await this._api.post("/customer/create", customer);
        return data;
    };

    update = async (customer) => {
        var data = await this._api.post("/customer/update", customer);
        return data;
    };







}
export default CustomerService;
